<div class="banner"
  *transloco="let t; lang: 'en|static' read: 'default_spotlight_theme.banner'">
  <!-- Add theme banner content here -->
</div>
